import React from 'react';
import PropTypes from 'prop-types';
import './PackGrid.css';
import PackGroup from './PackGroup.jsx';
import '../full.css';
import { gql, useQuery } from '@apollo/client';

var elementSize = "4";

const PACK_QUERY = gql`query PackGroupsQuery {
  packGroups(filters : {is_active: {eq:true}}) {
    name
    synth
    title
    packs {
      volume
    }
    cover {
      url
    }
  }
}
`;

export const PackGrid = ({showModal = false}) => {
  const { loading, error, data } = useQuery(PACK_QUERY)

  if(loading) return <h4>...loading</h4>
  if(error) return <h4>{error.message}</h4>

  let elementSize = 1
  if (data.packGroups.length >=4)
    elementSize = 3
  if (data.packGroups.length >=10)
    elementSize = 2
  if (data.packGroups.length >=19)
    elementSize = 1
  return (
    <div id="siteloader" data-jdpage="jdpage-videos" data-parent="" data-ultimate-parent="videos">
      <div id="jdpage-videos">
        <div id="videos" style={{padding:'100px'}}>
          <div className="column videoContainerColumn">
          <div className="row patches-row" style={{minHeight:'100%', backgroundColor: 'transparent'}}>
  
          <div className="small-12 large-12 large-centered columns" > 
            <div id="jdvideos" className={elementSize === 4 ? 'short-jdvideos' : null}>

              {/*
                Size 4 = 3 or less
                Size 3 = 4-8
                Size 2 = 10-18
                Size 1 = 18 <
              */}
              {
                data.packGroups.map(packGroup => (
                  <PackGroup gridElementSize={elementSize} key={packGroup.id} packGroup={packGroup} showModal={showModal}/>
                ))
              }
            </div>
          </div>
  
          </div>
          </div>
        </div>
      </div>
    </div>
  )
}
PackGrid.propTypes = {
  showModal: PropTypes.bool
}

export default PackGrid
